import { reactive, ref, watch } from "vue";
import {
  queryMaterielList,
  queryCategoryTree,
  deleteCategoryById,
  deleteMateriel,
} from "@/api/materiel";
import { queryDictList } from "@/api/dict";
import { DICT_KEY } from "@/constants/dict";
import { ElMessage, ElMessageBox } from "element-plus";

export default function useSupplies() {
  // 搜索条件
  const searchData = reactive({
    name: "",
    number: "",
    categoryId: null,
    brand: "",
    model: "",
    key: null,
  });

  // 搜索条件ref
  const searchRef = ref(null);

  // 物料分类ref
  const categoryRef = ref(null);

  // 物料管理的ref
  const materielRef = ref(null);

  // 树结构的ref
  const treeRef = ref(null);

  // 表格配置
  const columns = ref([
    {
      label: "物料名称",
      prop: "name",
      fixed: true,
      width: 150,
      showOverflowTooltip: true,
    },
    {
      label: "物料编号",
      prop: "number",
      width: 150,
      showOverflowTooltip: true,
    },
    {
      label: "物料类别",
      prop: "categoryName",
      width: 150,
      showOverflowTooltip: true,
    },
    // {
    //   label: "品牌",
    //   prop: "brand",
    // },
    {
      label: "规格型号",
      prop: "model",
    },
    {
      label: "单位",
      prop: "unit",
    },
    {
      label: "库存数",
      prop: "totalQuantity",
    },
    {
      label: "重点物料",
      prop: "key",
    },
    // {
    //   label: "供应商",
    //   prop: "supplier",
    // },
    {
      label: "创建人",
      prop: "createName",
    },
    {
      label: "创建时间",
      prop: "createTime",
      showOverflowTooltip: true,
    },
  ]);

  // 表格数据
  const tableData = ref([]);

  // 表格遮罩
  const tableLoading = ref(false);

  // 物料类别遮罩
  const treeLoading = ref(false);

  // 分页参数
  const pageParams = reactive({
    page: 1,
    size: 10,
    total: 0,
  });
  const handleSizeChange = (val) => {
    pageParams.size = val;
    pageParams.page = 1;
    getList();
  };
  const handleCurrentChange = (val) => {
    pageParams.page = val;
    getList();
  };

  // 品牌列表
  const brandList = ref([]);

  // 规格型号列表
  const modelList = ref([]);

  // 物料类型树
  const typeTree = ref([]);

  // 获取表格数据
  const getList = () => {
    tableLoading.value = true;
    queryMaterielList({
      ...searchData,
      page: pageParams.page,
      limit: pageParams.size,
    })
      .then((res) => {
        tableData.value = res.data.records;
        pageParams.total = res.data.total;
      })
      .finally(() => {
        tableLoading.value = false;
      });
  };

  // 获取类型树
  const getTypeTree = () => {
    treeLoading.value = true;
    queryCategoryTree()
      .then((res) => {
        if (JSON.stringify(res.data) != "{}") {
          typeTree.value = res.data || [];
        }
      })
      .finally(() => {
        treeLoading.value = false;
      });
  };

  // 重置按钮
  const handleReset = () => {
    searchRef.value?.resetFields();
    pageParams.page = 1;
    getList();
  };

  // 获取字典数据
  const getDictList = () => {
    queryDictList(DICT_KEY["brand"]).then((res) => {
      brandList.value = res.data || [];
    });
    queryDictList(DICT_KEY["model"]).then((res) => {
      modelList.value = res.data || [];
    });
  };

  // 树点击新增或编辑
  const handleCategoryAdjust = (node, data, type) => {
    categoryRef.value?.handleDialogOpen({
      node,
      data,
      type,
      tree: typeTree.value,
    });
  };

  // 点击类别删除
  const handleCategoryDelete = (data) => {
    // if (data.parentId == "0") return ElMessage.error("根节点不可删除");
    ElMessageBox.confirm("确定删除所选物料类别吗？", "警告", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "error",
    })
      .then(() => {
        deleteCategoryById(data.id).then((res) => {
          if (res.code == "2000") {
            ElMessage.success("操作成功");
            getTypeTree();
          }
        });
      })
      .catch(() => {});
  };

  // 点击类别
  const handleNodeClick = (val) => {
    // searchData.categoryId = val.parentId == "0" ? null : val.id;
    searchData.categoryId = val.id;
    getList();
  };
  // 类别搜索功能
  const filterText = ref("");
  watch(filterText, (val) => {
    treeRef.value.filter(val);
  });
  const filterNode = (value, data) => {
    console.log("搜索功能===>", data);

    if (!value) return true;
    return data.node.includes(value);
  };

  // 点击物料管理的新增或编辑
  const handleMaterielAdjust = (row, type, tree) => {
    materielRef.value?.handleDialogOpen({ row, type, tree });
  };

  // 点击物料删除
  const handleDelete = (row) => {
    ElMessageBox.confirm(`确定删除物料【${row.name}】吗?`, "删除", {
      confirmButtonText: "删除",
      cancelButtonText: "取消",
      type: "error",
    })
      .then(() => {
        deleteMateriel(row.id).then((res) => {
          if (res.code == "2000") {
            ElMessage.success("删除成功");
            getList();
          }
        });
      })
      .catch(() => {});
  };

  // 点击导入
  const uploadRef = ref(null);
  const handleUpload = () => {
    uploadRef.value?.handleDialogOpen();
  };
  // 导入参数
  const uploadConfig = reactive({
    templateUrl: "/material/download", // 模板下载的url
    name: "物料导入模板.xlsx", // 模板文件名
  });

  const typeUploadRef = ref(null);
  const handleTypeUpload = () => {
    typeUploadRef.value?.handleDialogOpen();
  };
  const typeUploadConfig = reactive({
    templateUrl: "/materialCategory/download", // 模板下载的url
    name: "物料类别导入模板.xlsx", // 模板文件名
  });
  return {
    searchData,
    searchRef,
    columns,
    tableData,
    tableLoading,
    pageParams,
    brandList,
    modelList,
    typeTree,
    treeRef,
    categoryRef,
    materielRef,
    treeLoading,
    getList,
    handleSizeChange,
    handleCurrentChange,
    handleReset,
    getDictList,
    getTypeTree,
    handleCategoryAdjust,
    handleCategoryDelete,
    handleNodeClick,
    filterText,
    filterNode,
    handleMaterielAdjust,
    handleDelete,
    handleUpload,
    uploadRef,
    uploadConfig,
    typeUploadRef,
    handleTypeUpload,
    typeUploadConfig,
  };
}
